export class GenericResult {
    public result: boolean = false;
    public id: number = 0;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, { result: json.item1, id: json.item2 });
    }
}
